import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, MapPinIcon, ArrowRightIcon } from 'lucide-react';
import { navGroups } from '../data/navigation';
import { serviceAreaLocations } from '../data/content';
type AccordionMenuProps = {
  onNavigate: () => void;
};
const ease = [0.23, 1, 0.32, 1] as const;
const AREAS_ID = 'areas';
export function AccordionMenu({
  onNavigate
}: AccordionMenuProps) {
  const [openId, setOpenId] = useState<string>(navGroups[0].id);
  const toggle = (id: string) => setOpenId(cur => cur === id ? '' : id);
  const goToArea = (name: string) => {
    onNavigate();
    document.getElementById('service-areas')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    window.dispatchEvent(new CustomEvent('select-service-area', {
      detail: name
    }));
  };
  const sections = [...navGroups.map(g => ({
    id: g.id,
    label: g.label
  })), {
    id: AREAS_ID,
    label: 'Service areas'
  }];
  return <div className="divide-y divide-stone-line" data-id="element-16" data-mp="3a50dmixj4ghk">
      {sections.map(section => {
      const open = openId === section.id;
      const panelId = `menu-panel-${section.id}`;
      const group = navGroups.find(g => g.id === section.id);
      return <div key={section.id} data-id="element-17" data-mp="304q2d3v21j51">
            <h3 data-id="element-18" data-mp="2v7q4vhc9topj">
              <button type="button" aria-expanded={open} aria-controls={panelId} onClick={() => toggle(section.id)} className="flex w-full items-center justify-between py-4 text-left font-display text-lg font-bold text-forest" data-id="element-19" data-mp="2v89bw30dusos">
                {section.label}
                <ChevronDownIcon className={`h-5 w-5 text-ink-muted transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-20" data-mp="2mdbgmp9rj3ua" />
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-21" data-mp="2cf5h2ebfi9sl">
              {open && <motion.div id={panelId} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease
          }} className="overflow-hidden" data-id="element-22" data-mp="27glse65gajwj">
                  {group ? <ul className="pb-4" data-id="element-23" data-mp="1jurxh6uxoti7">
                      {group.links.map(link => <li key={link.href} data-id="element-24" data-mp="1jwl78v0uftuf">
                          <a href={link.href} onClick={onNavigate} className="group flex items-center justify-between gap-4 rounded-lg px-3 py-2.5 transition-colors duration-150 hover:bg-stone-soft" data-id="element-25" data-mp="1ostfrpkjcosm">
                            <span data-id="element-26" data-mp="2gl0x6s7v8582">
                              <span className="block text-sm font-semibold text-ink" data-id="element-27" data-mp="2gjzk6i7ah8np">{link.label}</span>
                              {link.description && <span className="block text-xs text-ink-muted" data-id="element-28" data-mp="22rjltupc1yt4">{link.description}</span>}
                            </span>
                            <ArrowRightIcon className="h-4 w-4 shrink-0 text-ink-muted transition-transform duration-150 ease-out group-hover:translate-x-0.5 group-hover:text-forest" aria-hidden="true" data-id="element-29" data-mp="2vhrvsz9ptcwm" />
                          </a>
                        </li>)}
                    </ul> : <ul className="grid grid-cols-2 gap-1 pb-4" data-id="element-30" data-mp="35lym2662aov9">
                      {serviceAreaLocations.map(area => <li key={area.name} data-id="element-31" data-mp="3jddf75too6g1">
                          <button type="button" onClick={() => goToArea(area.name)} className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm font-medium text-ink transition-colors duration-150 hover:bg-stone-soft hover:text-forest" data-id="element-32" data-mp="3jc21ad6ixib7">
                            <MapPinIcon className="h-4 w-4 shrink-0 text-leaf" aria-hidden="true" data-id="element-33" data-mp="2mndwwjnqdtk9" />
                            {area.name}
                          </button>
                        </li>)}
                    </ul>}
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}